import React from 'react';
import { FearAndGreedReading } from '../types';
import Gauge from './Gauge';

interface FearAndGreedIndexProps {
  data: FearAndGreedReading | null;
  loading: boolean;
  error: string | null;
}

const FearAndGreedIndex: React.FC<FearAndGreedIndexProps> = ({ data, loading, error }) => {
  const getSentimentColor = (classification: string) => {
    switch (classification) {
      case 'Extreme Fear':
        return 'text-red-500';
      case 'Fear':
        return 'text-orange-500';
      case 'Neutral':
        return 'text-yellow-500';
      case 'Greed':
        return 'text-lime-500';
      case 'Extreme Greed':
        return 'text-green-500';
      default:
        return 'text-light-blue';
    }
  };


  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center h-full">
          <p className="text-light-blue animate-pulse">Loading Index...</p>
        </div>
      );
    }
    if (error) {
      return (
        <div className="flex items-center justify-center h-full">
            <p className="text-center text-red-400">Could not load index data.</p>
        </div>
      );
    }
    if (data) {
      return (
        <div className="flex flex-col items-center justify-center w-full">
          <Gauge value={parseInt(data.value, 10)} />
          <div className="text-center">
            <p className="text-5xl font-bold text-off-white">{data.value}</p>
            <p className={`text-lg font-semibold ${getSentimentColor(data.value_classification)}`}>
              {data.value_classification}
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-navy-blue p-6 rounded-lg shadow-xl flex flex-col justify-between h-full">
      <div>
        <h3 className="text-light-blue text-lg">Fear & Greed Index</h3>
      </div>
      <div className="flex-grow flex items-center justify-center mt-2">
        {renderContent()}
      </div>
    </div>
  );
};

export default FearAndGreedIndex;
